/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import AppIncidents from '@zapier/product-get-help/esm/components/other/Incidents/AppIncidents';
import CollapsedBlock from '@zapier/product-get-help/esm/components/blocks/CollapsedBlock';
import ZapIcons from '../ZapIcons';
import { DEFAULT_ZAP_NAME } from '../constants';
import { getSelectedZap } from '../utils';
const gridCss = css `
  align-items: center;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: min-content 1fr;
`;
/** Renders `<ZapBlock>` when it is closed. */
const Closed = ({ data, disableIncidents = false, isConfirming = false, isLoading = false, kindDisplayName, onClickEdit, onSelect, selectedZap: _selectedZap, size, title, }) => {
    const selectedZap = getSelectedZap({
        data,
        isLoading,
        onSelect,
        selectedZap: _selectedZap,
    });
    const selectedApis = selectedZap
        ? selectedZap.nodes
            .map(({ selectedApi }) => selectedApi || '')
            .filter(selectedApi => !!selectedApi)
        : [];
    const footer = !disableIncidents && selectedApis.length > 0 ? (isolateComponent(AppIncidents, { implementationIds: selectedApis })) : null;
    return (isolateComponent(CollapsedBlock, { footer: footer, isDimmed: !isConfirming, onClickEdit: onClickEdit, size: size, title: title }, selectedZap ? (isolateComponent("div", { css: gridCss },
        isolateComponent(ZapIcons, { nodes: selectedZap.nodes }),
        ' ',
        isolateComponent("span", null, selectedZap.title || DEFAULT_ZAP_NAME))) : (isolateComponent("p", null,
        "You have not selected a ",
        kindDisplayName,
        "."))));
};
export default Closed;
